import { render, staticRenderFns } from "./CategoryGasto.vue?vue&type=template&id=1c1825dc&scoped=true&"
import script from "./CategoryGasto.vue?vue&type=script&lang=js&"
export * from "./CategoryGasto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1825dc",
  null
  
)

export default component.exports